import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88d3ff3c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=88d3ff3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d3ff3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d3ff3c')) {
      api.createRecord('88d3ff3c', component.options)
    } else {
      api.reload('88d3ff3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88d3ff3c&scoped=true&", function () {
      api.rerender('88d3ff3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DevLayout/toolbar/index.vue"
export default component.exports